<template>
  <div>
    <ShareNetwork
      network="twitter"
      :url="url"
      :title="title"
      :quote="quote"
      :hashtags="hashtags"
    >
      <i class="lg el-icon-share"></i>
    </ShareNetwork>
  </div>
</template>
<script>
export default {
  props: {
    url: String,
    title: String,
    quote: String,
    hashtags: String
  }
};
</script>
